import { getElectronStores } from '../../stores/electronStores';
import { populateDisplaySelection } from '../managers/mediaManager';

const electronState = getElectronStores();

/**
 * PlayJector activates ShadowCam03 in host-electron's getSources handler ~700 ms after
 * boot. MediaCoordinator already re-enumerates on `devicechange`; legacy preview still
 * reads `videoState.shadowcams` via populateDisplaySelection — keep it in sync.
 */
export const initializeDriverEvents = () => {
  populateDisplaySelection();
  electronState.driverState.addListener((driverState) => {
    console.debug('[Drivers]', driverState);
    populateDisplaySelection();
  });

  if (typeof navigator !== 'undefined' && navigator.mediaDevices?.addEventListener) {
    navigator.mediaDevices.addEventListener('devicechange', () => {
      console.debug('[Drivers] devicechange — refreshing camera/shadowcam lists for preview');
      populateDisplaySelection();
    });
  }
};
